export default function Heading1({ text }) {
  return <div className="font-semibold text-secondary-foreground">{text}</div>;
}
